var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1982 9.69856L18.0035 2.89327C18.2377 2.65078 18.3673 2.32601 18.3643 1.9889C18.3614 1.65179 18.2262 1.32931 17.9878 1.09093C17.7494 0.852551 17.4269 0.717333 17.0898 0.714404C16.7527 0.711475 16.428 0.841067 16.1855 1.07527L9.38018 7.88056L2.57489 1.07527C2.3324 0.841067 2.00763 0.711475 1.67052 0.714404C1.33341 0.717333 1.01094 0.852551 0.772555 1.09093C0.534173 1.32931 0.398956 1.65179 0.396027 1.9889C0.393097 2.32601 0.52269 2.65078 0.756893 2.89327L7.56218 9.69856L0.756893 16.5038C0.634094 16.6224 0.536146 16.7643 0.468763 16.9212C0.40138 17.078 0.365912 17.2468 0.364428 17.4175C0.362945 17.5882 0.395476 17.7575 0.460123 17.9155C0.524769 18.0735 0.620238 18.2171 0.740957 18.3378C0.861676 18.4585 1.00523 18.554 1.16324 18.6186C1.32125 18.6833 1.49055 18.7158 1.66127 18.7143C1.83198 18.7128 2.00069 18.6774 2.15756 18.61C2.31442 18.5426 2.45629 18.4446 2.57489 18.3218L9.38018 11.5166L16.1855 18.3218C16.428 18.556 16.7527 18.6856 17.0898 18.6827C17.4269 18.6798 17.7494 18.5446 17.9878 18.3062C18.2262 18.0678 18.3614 17.7453 18.3643 17.4082C18.3673 17.0711 18.2377 16.7463 18.0035 16.5038L11.1982 9.69856Z",
    fill: "#686876"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.166b0fd5adaaaed1eaa625f32e832e9c.svg";
export { ForwardRef as ReactComponent };